if (!customElements.get("qa-upsell")) {
  class QAUpsell extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector(".qa-upsell__form");
      this.submitBtn = this.querySelector(".qa-upsell__submit");
      this.tooltip = this.querySelector(".qa-upsell__tooltip");
      this.drawer = this.closest("quick-add-drawer");

      // on any radio change, update button/tooltip state
      this.form.addEventListener("change", () => this.updateState());
      // on click, either shake or submit
      this.submitBtn.addEventListener("click", () => this.handleSubmit());

      // Listen for variant changes to update prices
      this.addEventListener("on:variant:change", QAUpsell.updateVariantPrice);

      this.updateState();
    }

    /**
     * Called by the drawer on close()
     */
    reset() {
      this.form.reset(); // clear all radios
      this.updateState(); // re‑disable the button + show tooltip
    }

    updateState() {
      const sel = this.form.querySelector(
        'input[name="qa_upsell_select"]:checked'
      );

      if (!sel) {
        // Always enabled - just update text and hide tooltip
        this.submitBtn.classList.remove("disabled");
        this.tooltip.classList.add("hidden");
        // default to "No" text when nothing is selected
        this.submitBtn.textContent = this.submitBtn.dataset.textNo;
      } else {
        // Always enabled - just update text and hide tooltip
        this.submitBtn.classList.remove("disabled");
        this.tooltip.classList.add("hidden");
        this.submitBtn.textContent =
          sel.value === "yes"
            ? this.submitBtn.dataset.textYes
            : this.submitBtn.dataset.textNo;
      }
    }

    async handleSubmit() {
      const sel = this.form.querySelector(
        'input[name="qa_upsell_select"]:checked'
      );
      let variantId;

      const selectedValue = sel ? sel.value : "no";

      if (selectedValue === "yes") {
        // Upsell: prefer whatever the upsell variant-picker says
        const picker = this.querySelector("variant-picker");
        variantId =
          picker && picker.variant ? picker.variant.id : sel.dataset.variantId;
      } else {
        // take the live variant id from the main picker in the drawer
        const mainPicker = this.drawer.querySelector(
          ".product-options variant-picker"
        );
        variantId =
          mainPicker && mainPicker.variant
            ? mainPicker.variant.id // most reliable
            : this.dataset.variantId || this.drawer.form.getCurrentVariantId(); // fallback
      }

      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
        this.drawer.close();
      } catch (err) {
        console.error("[QA‑Upsell]", err);
      }
    }

    /**
     * Updates variant prices when variants change
     * @param {Event} event - The variant change event
     */
    static updateVariantPrice(event) {
      const variantPicker = event.target;
      if (!variantPicker || !variantPicker.variant) return;

      // Find the price element in the same container as the variant picker
      const container =
        variantPicker.closest(".qa-upsell__item") ||
        variantPicker.closest(".qa-upsell__options");
      if (!container) return;

      // First check for standard price component
      const priceElement = container.querySelector(".price");
      if (priceElement) {
        const priceCurrentEl = priceElement.querySelector(".price__current");
        const priceWasEl = priceElement.querySelector(".price__was");

        if (priceCurrentEl) {
          priceCurrentEl.innerHTML =
            variantPicker.data.formatted[variantPicker.variant.id].price;
        }

        if (priceWasEl) {
          priceWasEl.innerHTML =
            variantPicker.data.formatted[variantPicker.variant.id]
              .compareAtPrice || "";
          priceElement.classList.toggle(
            "price--on-sale",
            variantPicker.variant.compare_at_price > variantPicker.variant.price
          );
        }
      }

      // Also update the qa-upsell__price element
      const upsellPriceEl = container.querySelector(".qa-upsell__price");
      if (upsellPriceEl) {
        upsellPriceEl.innerHTML =
          variantPicker.data.formatted[variantPicker.variant.id].price;
      }
    }
  }

  customElements.define("qa-upsell", QAUpsell);
}
